import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogGuide from "../pages/blog/gtbuy-spreadsheet-shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/gtbuy-spreadsheet-shopping-guide",
    element: <BlogGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;